import react from "react";
import Request from "./api/Requests";
const userRequest = () => {
    return Request('user/info', 'GET', {}, true);
}


export default {
    userRequest
}